import LoginPage from "../Pages/LoginPage.vue";
import RegisterPage from "../Pages/RegisterPage.vue";
import AuthPasswordLayout from "../Pages/AuthPasswordLayout.vue";
import PasswordResetPage from "../Pages/PasswordResetPage.vue";
import PasswordResetDone from "../Pages/PasswordResetDone.vue";
import PasswordResetConfirm from "../Pages/PasswordResetConfirm.vue";
import PasswordResetComplete from "../Pages/PasswordResetComplete.vue";

export let AuthenticationRoutes = [
  {
    path: "login/",
    name: "Login",
    component: LoginPage,
    props: true,
  },
  {
    path: "signup/",
    name: "Register",
    component: RegisterPage,
    props: true,
  },
  {
    path: "password/",
    name: "AuthPassword",
    component: AuthPasswordLayout,
    children: [
      {
        path: "reset/",
        name: "PasswordReset",
        component: PasswordResetPage,
      },
      {
        path: "reset/done/",
        name: "PasswordResetDone",
        component: PasswordResetDone,
      },
      {
        path: "reset/confirm/:token/",
        name: "PasswordResetConfirm",
        component: PasswordResetConfirm,
        props: true,
      },
      {
        path: "reset/complete/",
        name: "PasswordResetComplete",
        component: PasswordResetComplete,
      },
    ],
  },
];
